import _asyncToGenerator from "/builds/huggg/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { translateObject } from '@huggg/bar-staff';
import { prop } from 'ramda';
import { urls } from '../config';
import withAxios from '../utils/with-axios';
import { chargeMap } from '../translationMaps';
function formatCharge(data) {
  var charge = data.data;
  var translated = translateObject(chargeMap, charge);
  return translated;
}

/**
 * Create a new charge.
 *
 * @param {Object} $axios [$axios=axios] Axios instance.
 * @param {String} method The payment method, usually 'checkout.com'
 * @param {Integer} amount The amount in pennies to charge
 * @param {Object} data The data object (originating from checkout tokenization)
 * @param {String} data.token The tokenized card
 * @param {Boolean} storeCard Whether to store the card or not. This is only used on a tokenized charge
 * @param {String} recurring Whether this charge is recurring or not
 * @param {String} cardId The ID of the card to use for this payment
 * @param {String} userId The ID of the user this charge is for
 * @returns {Promise} Unresolved Promise from the API.
 */
function create(_x, _x2) {
  return _create.apply(this, arguments);
}
/**
 * Verifies a charge using a cko-session-id provided after 3D-Secure
 *
 * @param {Object} $axios [$axios=axios] Axios instance.
 * @param {String} id The charge id
 * @param {String} ckoSessionId The CKO Session ID
 * @returns {Promise} Unresolved Promise from the API.
 */
function _create() {
  _create = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee($axios, chargePayload) {
    var request;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          request = {
            method: chargePayload.method,
            amount: chargePayload.amount,
            data: chargePayload.data,
            storeCard: chargePayload.storeCard,
            recurring: Boolean(chargePayload.recurring),
            cardId: chargePayload.cardId,
            userId: chargePayload.userId
          };
          return _context.a(2, $axios.post(urls.apiV2("/charges"), request).then(prop('data')).then(formatCharge));
      }
    }, _callee);
  }));
  return _create.apply(this, arguments);
}
function verify(_x3, _x4, _x5) {
  return _verify.apply(this, arguments);
}
function _verify() {
  _verify = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2($axios, id, ckoSessionId) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, $axios.post(urls.apiV2("/charges/".concat(id, "/verify")), {
            ckoSessionId: ckoSessionId
          }).then(prop('data')).then(formatCharge));
      }
    }, _callee2);
  }));
  return _verify.apply(this, arguments);
}
export default {
  create: withAxios(create, {
    useBackoff: false
  }),
  verify: withAxios(verify)
};